// extracted by mini-css-extract-plugin
export default {"root":"ScreeningActivationSuccessFragment_root__6fBrf","divider":"ScreeningActivationSuccessFragment_divider__69K6r"};